<div class="edit-package-container" #packageContainer>
  <div class="header">
    <pdq-button variant="light" icon="side_left_arrow" size="large" (onClick)="navigateToPackages()"> </pdq-button>
    <div class="title">{{ isNew ? 'Add' : 'Edit' }} package</div>
  </div>
  <div class="tabs-wrapper">
    <pdq-tabs-group
      class="edit-packages-tabs"
      (onChange)="onTabSelection($event, true)"
      variant="underline"
      leftMargin="none"
      bgColor="white"
      [selectFirstDefault]="false">
      @for (tab of tabs; track tab) {
        <pdq-tab [value]="tab.value" [active]="tab.active" [label]="tab.label"> </pdq-tab>
      }
    </pdq-tabs-group>
    <article class="content">
      @if (tabs[0].active) {
        <app-settings-edit-custom-package
          [boxData]="boxData"
          [unavailableKeyBinds]="unavailableKeyBinds"
          [boxesData]="boxesData"></app-settings-edit-custom-package>
      }
      @if (tabs[1].active) {
        <app-settings-edit-carrier-package
          [boxData]="boxData"
          [boxesData]="boxesData"
          [unavailableKeyBinds]="unavailableKeyBinds"
          (scrollToBottom)="scrollToBottom()"></app-settings-edit-carrier-package>
      }
    </article>
  </div>
</div>
